export const globalErrorForMetrics = {
  error_code: '',
  error_message: ''
}
